import React from "react";
import { Icon, ReduxControls } from "rhombus-react";
import { useDispatch } from "react-redux";
import { SUBMIT_QR_CODE_FORM } from "forms/list";
import { arrayPush } from "redux-form";
import { ExtraParametersRows } from "widgets/modals/qr-codes/ExtraParametersRows";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

export const ExtraParametersFields = ({ readOnly }) => {
	const dispatch = useDispatch();
	useTooltipRebuild();

	return (
		<ReduxControls.RowController
			name="extraParams"
			disabled={readOnly}
			label={
				<span data-testid="extra-params-label">
					Extra Parameters
					<Icon
						data-tip="Valid characters for this field are: 'A-Z', 'a-z', '0-9', '-', '_', '.', and whitespaces"
						name="fas fa-info-circle"
						className={"info-icon-extra-params"}
						data-testid="info-extra-params-icon"
					/>
				</span>
			}
			manuallyAddRow
			addRowLabel="Add Another Parameter"
			addButtonProps={{
				className: "add-param-button",
				onClick: () => {
					dispatch(arrayPush(SUBMIT_QR_CODE_FORM, "extraParams", { key: '', value: '' }));
				},
			}}
			component={ExtraParametersRows}
		/>
	);
};

ExtraParametersFields.displayName = "ExtraParametersFields";
